<mat-toolbar class="app-header">
  <div class="app-header__brand">
    <img class="app-header__logo" src="chevron_logo.png" alt="Chevron" />
  </div>

  <span class="app-header__title">{{ appName }}</span>

  <button
    mat-button
    class="app-header__identity"
    [matMenuTriggerFor]="accountMenu"
    aria-label="Open account menu"
  >
    <span class="app-header__greeting" style="margin: 1vh;">Hello, {{ userName }}</span>
    <span class="app-header__avatar" aria-hidden="true">
      {{ userInitials }}
    </span>
    <span class="app-header__chevron" aria-hidden="true">&#9662;</span>
  </button>

  <mat-menu #accountMenu="matMenu">
    <button mat-menu-item type="button" (click)="logout()">Logout</button>
  </mat-menu>
</mat-toolbar>
